import React, { useEffect, useState } from 'react';
import { getServices } from '../api';
import api from '../api';

const s = {
    h1:    { fontSize: 22, fontWeight: 700, marginBottom: 20 },
    box:   { background: '#fff', borderRadius: 10, padding: 28, boxShadow: '0 1px 4px rgba(0,0,0,.06)', maxWidth: 680 },
    label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6, marginTop: 16 },
    input: { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14 },
    sel:   { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, background: '#fff' },
    btn:   { marginTop: 24, width: '100%', padding: '12px 0', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 15, cursor: 'pointer' },
    info:  { marginTop: 16, padding: '12px 16px', background: '#f0f4ff', borderRadius: 8, fontSize: 13 },
    err:   { marginTop: 12, color: '#ef4444', fontSize: 13 },
    ok:    { marginTop: 12, padding: '12px 16px', background: '#d1fae5', borderRadius: 8, fontSize: 13, color: '#065f46' },
    catH:  { fontSize: 12, fontWeight: 700, color: '#6b7280', padding: '8px 0 4px', background: '#fff', pointerEvents: 'none' },
};

const LINK_PLACEHOLDER = {
    USERNAME: 'e.g. username, https://instagram.com/username, or story link',
    POST_URL:  'https://instagram.com/p/ABC123/',
    STORY_URL: 'https://instagram.com/stories/username/123456789/',
    REEL_URL:  'https://instagram.com/reel/ABC123/',
};

const LINK_HINT = {
    USERNAME: { label: 'Username or Story Link', examples: ['username', 'https://instagram.com/username', 'https://instagram.com/stories/username/123456/'] },
    POST_URL: { label: 'Post URL', examples: ['https://instagram.com/p/ABC123/', 'https://instagram.com/username/p/ABC123/'] },
    STORY_URL: { label: 'Story URL', examples: ['https://instagram.com/stories/username/123456789/'] },
    REEL_URL: { label: 'Reel URL', examples: ['https://instagram.com/reel/ABC123/', 'https://instagram.com/reels/ABC123/'] },
};

export default function NewOrder() {
    const [services, setServices] = useState([]);
    const [selected, setSelected] = useState(null);
    const [serviceSearch, setServiceSearch] = useState('');
    const [link, setLink] = useState('');
    const [quantity, setQuantity] = useState('');
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [balance, setBalance] = useState(0);
    const [serviceEta, setServiceEta] = useState({});
    const [seedText, setSeedText] = useState('');  // enhanced comments: raw textarea
    const [seedError, setSeedError] = useState('');

    useEffect(() => {
        const client = JSON.parse(localStorage.getItem('client') || '{}');
        setBalance(parseFloat(client.balance || 0));

        getServices()
            .then(r => {
                const list = Array.isArray(r.data) ? r.data : [];
                setServices(list);
                // Check URL param for pre-selected service
                const params = new URLSearchParams(window.location.search);
                const preselect = params.get('service');
                const preCategory = params.get('category');
                if (preselect) {
                    const found = list.find(s => String(s.service) === preselect);
                    if (found) { setSelected(found); return; }
                }
                if (preCategory) {
                    const found = list.find(s => s.category === preCategory);
                    if (found) { setSelected(found); return; }
                }
                if (list.length) setSelected(list[0]);
            })
            .catch(console.error)
            .finally(() => setLoading(false));

        // Fetch service ETA
        fetch('/public/service-eta').then(r => r.json())
            .then(d => { if (d && d.eta) setServiceEta(d.eta); })
            .catch(() => {});
    }, []);

    // Filter services by search (name or ID)
    const filteredServices = serviceSearch.trim()
        ? services.filter(s => {
            const q = serviceSearch.trim().toLowerCase();
            return String(s.service).includes(q) || s.name.toLowerCase().includes(q);
        })
        : services;

    // Group services by category
    const categories = filteredServices.reduce((acc, svc) => {
        (acc[svc.category] = acc[svc.category] || []).push(svc);
        return acc;
    }, {});

    const svc = selected;
    const effectiveMax = svc?.max || 1000;
    const effectiveMin = svc?.min || 1;
    const qty = parseInt(quantity) || 0;
    const pricePerUnit = svc ? parseFloat(svc.rate) / 1000 : 0;
    const total = pricePerUnit * qty;

    const isEnhanced = svc && svc.task_type && svc.task_type.endsWith('_enhanced');

    const parseSeedComments = (text) => text.split('\n').map(l => l.trim()).filter(l => l.length > 0);

    const SEED_EXACT_FE = [
        // Spam
        'spam','buy followers','link in bio','check my bio','check my profile',
        'follow for follow','f4f','follow back','free followers','click here',
        'promo code','discount code','earn money','make money','get rich',
        'bit.ly','t.me','onlyfans',
        // EN porn/sex explicit
        'porn','porno','pornhub','xxx','nudes','nude photo','nude pic',
        'sex tape','sex video','leaked video','blowjob','handjob','cumshot','creampie','gangbang',
        // IT multi-word
        'vaffanculo','va fanculo','fanculo','porco dio','porcodio','porca madonna','porcamadonna',
        'dio cane','figlio di put','coglion','stronzat','puttanat','troia di',
        // EN multi-word
        'motherfucker','son of a bitch','piece of shit','go fuck',
        // ES multi-word
        'hijo de puta','hija de puta','me cago en','vete a la mierda','que te jodan','te voy a matar',
        // DE multi-word
        'fick dich','hurensohn','verpiss dich','halt die fresse','pornovideo','sexvideo',
        // FR multi-word
        'va te faire foutre','fils de pute','ta gueule','nique ta mere','nique ta mère','je vais te tuer',
        // PT multi-word
        'filho da puta','filha da puta','vai se foder','vai tomar no','puta merda',
        // TR multi-word
        'seni sikerim','orospu cocugu','orospu çocuğu','siktir git','amına koyayım','porno video',
        // RU Cyrillic
        'блять','блядь','пиздец','пизда','хуй','хуйня','ебать','ёбаный','иди нахуй','пошёл нахуй','нахуй',
        'порно','секс видео','голая','голый',
        // JA Japanese
        '死ね','殺す','殺してやる','まんこ','ちんこ','ちんぽ','おっぱい','エロ動画','セックス','ポルノ',
        'くそ野郎','うせろ','ざけんな',
        // AR Arabic
        'كس أمك','كس','عيرك','زب','شرموطة','يلعن','منيك','ابن الشرموطة','ابن القحبة','نيك','سكس',
        'بورن','عاهرة','اغتصاب','سأقتلك',
        // ZH Chinese
        '操你','肏你','肏你妈','妈的','傻逼','狗屎','滚蛋','去死','色情','裸体','强奸','性爱','干你妈',
    ];
    const SEED_WORD_FE = [
        // EN
        'fuck','fucking','fucker','shit','bitch','cunt','cock','dick','pussy','whore','slut','bastard','asshole','jackass',
        // EN slurs
        'nigger','nigga','faggot','fag','retard','spic','chink','kike','dyke',
        // IT
        'cazzo','cazzi','minchia','figa','fica','troia','puttana','merda','stronzo','stronza','bastardo','coglione',
        'idiota','imbecille','deficiente','ritardato',
        // ES
        'puta','puto','coño','joder','mierda','hostia','gilipollas','capullo','maricón','maricon',
        'pendejo','cabrón','cabron','polla','follar','chingar','verga','culero',
        // DE
        'fick','ficken','scheiße','scheisse','arschloch','wichser','hure','nutte','schlampe','vollidiot','wichsen',
        // FR
        'putain','merde','connard','connasse','salope','pute','baiser','niquer','enculé','encule','foutre','bordel',
        // PT
        'porra','caralho','foda','foder','viado','buceta','xereca','safada','arrombado',
        // TR
        'sik','sikme','orospu','kahpe','bok','siktir','piç','ibne',
        // Violence/threats multilingual
        'kill','murder','rape','terrorist','suicide','ammazzati','matar','töten','tuer','öldür',
        // Sexual standalone
        'sesso','scopare','fottere','naked','nude',
    ];
    const validateSeeds = (seeds) => {
        if (seeds.length === 0) return 'Enter at least one example comment';
        if (seeds.length > 20) return 'Max 20 example comments';
        // 2026-10-19 (Francesco): insulti/link/menzioni NON bloccano piu' l'ordine: li scarta il server
        // (cleanSeedComments) e l'ordine viene consegnato con testi puliti, come dice la descrizione.
        return null;
    };

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setSeedError('');
        if (!selected) { setError('Select a service'); return; }
        if (!link.trim()) { setError('Enter a link'); return; }
        // 2026-06-17: solo link Instagram. Un URL http che non è instagram.com (X/Twitter, TikTok,
        // YouTube, Facebook...) non è valido → blocca nel form invece di creare un ordine in errore.
        if (/^https?:\/\//i.test(link.trim()) && !link.trim().toLowerCase().includes('instagram.com')) {
            setError('Only Instagram links are supported (instagram.com) — not X/Twitter, TikTok, YouTube, etc.');
            return;
        }
        if (qty < effectiveMin || qty > effectiveMax) {
            setError(`Quantity must be between ${effectiveMin} and ${effectiveMax}`);
            return;
        }
        let seedComments = null;
        if (isEnhanced) {
            seedComments = parseSeedComments(seedText);
            const seedErr = validateSeeds(seedComments);
            if (seedErr) { setSeedError(seedErr); return; }
        }
        setSubmitting(true);
        try {
            const res = await api.post('/api/v2', {
                action: 'add',
                service: selected.service,
                link: link.trim(),
                quantity: qty,
                ...(seedComments ? { seed_comments: seedComments } : {}),
            });
            if (res.data.error) {
                if (res.data.existing_order_id) {
                    setError(`${res.data.error}`);
                } else {
                    setError(res.data.error);
                }
                return;
            }
            setSuccess(`Order #${res.data.order} placed successfully! Total charged: €${total.toFixed(4)}`);
            setLink('');
            setQuantity('');
        } catch (err) {
            setError(err.response?.data?.error || err.message);
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) return <div>Loading services...</div>;

    return (
        <div>
            <h1 style={s.h1}>New Order</h1>
            <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>{services.length} active services across {Object.keys(categories).length} categories</div>
            <div style={s.box}>
                <form onSubmit={submit}>
                    {/* 1. SERVICE */}
                    <label style={s.label}>Service</label>
                    <input
                        style={{ ...s.input, marginBottom: 6 }}
                        type="text"
                        placeholder="Search by name or ID (e.g. 1038, story reply, comment...)"
                        value={serviceSearch}
                        onChange={e => {
                            const q = e.target.value;
                            setServiceSearch(q);
                            // Auto-select if exactly one match
                            if (q.trim()) {
                                const matches = services.filter(s => {
                                    const lq = q.trim().toLowerCase();
                                    return String(s.service).includes(lq) || s.name.toLowerCase().includes(lq);
                                });
                                if (matches.length === 1) setSelected(matches[0]);
                            }
                        }}
                    />
                    {serviceSearch.trim() && (
                        <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>
                            {filteredServices.length} result{filteredServices.length !== 1 ? 's' : ''}
                            {' '}<span style={{ cursor: 'pointer', color: '#6366f1', textDecoration: 'underline' }}
                                onClick={() => setServiceSearch('')}>clear</span>
                        </div>
                    )}
                    <select style={s.sel} value={selected?.service || ''} onChange={e => {
                        const svc = services.find(s => String(s.service) === e.target.value);
                        setSelected(svc || null);
                    }}>
                        {Object.entries(categories).map(([cat, svcs]) => (
                            <optgroup key={cat} label={cat}>
                                {svcs.map(s => (
                                    <option key={s.service} value={s.service}>
                                        [{s.service}] {s.name} — €{parseFloat(s.rate).toFixed(4)}/1k (min {s.min}, max {s.max})
                                    </option>
                                ))}
                            </optgroup>
                        ))}
                    </select>

                    {svc && (
                        <div style={{ ...s.info, lineHeight: 1.7 }}>
                            <div style={{ whiteSpace: 'pre-line', marginBottom: 10, fontSize: 13 }}>
                                {svc.description || svc.name}
                            </div>
                            <div style={{ fontSize: 12, color: '#6b7280', borderTop: '1px solid #e5e7eb', paddingTop: 8 }}>
                                <strong>Rate:</strong> €{parseFloat(svc.rate).toFixed(2)}/1k &nbsp;|&nbsp;
                                <strong>Min:</strong> {svc.min} &nbsp;|&nbsp;
                                <strong>Max:</strong> {svc.max}
                            </div>
                            {(() => {
                                const eta = serviceEta[svc.task_type] || { label: 'Starting now', speed_per_hour: 0, start_min: 0 };
                                const isNow = eta.label === 'Starting now';
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, paddingTop: 8, borderTop: '1px solid #e5e7eb' }}>
                                        <span style={{
                                            display: 'inline-flex', alignItems: 'center', gap: 4,
                                            fontSize: 12, fontWeight: 600, padding: '4px 10px', borderRadius: 6,
                                            background: isNow ? '#d1fae5' : '#fef3c7',
                                            color: isNow ? '#065f46' : '#92400e',
                                        }}>
                                            {isNow ? '⚡' : '🕐'} Estimated start: {eta.label}
                                        </span>
                                    </div>
                                );
                            })()}
                        </div>
                    )}

                    {/* 2. LINK */}
                    <label style={s.label}>Link / Username</label>
                    <input
                        style={s.input}
                        type="text"
                        value={link}
                        onChange={e => { e.target.setCustomValidity(''); setLink(e.target.value); }}
                        onInvalid={e => e.target.setCustomValidity('Please fill in this field')}
                        placeholder={svc ? LINK_PLACEHOLDER[svc.link_type] || 'Enter link or username' : ''}
                        required
                    />
                    {svc && LINK_HINT[svc.link_type] && (
                        <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>
                            <strong>Accepted format:</strong> {LINK_HINT[svc.link_type].label}
                            <br />
                            {LINK_HINT[svc.link_type].examples.map((ex, i) => (
                                <span key={i} style={{ display: 'inline-block', background: '#f3f4f6', padding: '2px 8px', borderRadius: 4, marginTop: 4, marginRight: 6, fontFamily: 'monospace', fontSize: 11 }}>
                                    {ex}
                                </span>
                            ))}
                        </div>
                    )}

                    {/* 2b. SEED COMMENTS (enhanced orders only) */}
                    {isEnhanced && (
                        <div style={{ marginTop: 16 }}>
                            <label style={s.label}>
                                {svc && svc.task_type === 'send_dm_enhanced' ? 'Your example messages' : 'Your example comments'} <span style={{ fontWeight: 400, color: '#9ca3af' }}>(1–20, one per line)</span>
                            </label>
                            <textarea
                                style={{ ...s.input, minHeight: 100, resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }}
                                value={seedText}
                                onChange={e => { setSeedText(e.target.value); setSeedError(''); }}
                                placeholder={"Great product, highly recommend!\nLove the quality\nExactly what I was looking for"}
                                required={isEnhanced}
                            />
                            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
                                We'll generate unique variations that match your tone. Insults, links, @mentions and phone numbers are automatically removed.
                            </div>
                            {seedError && (
                                <div style={{ fontSize: 12, color: '#ef4444', marginTop: 4 }}>{seedError}</div>
                            )}
                        </div>
                    )}

                    {/* 3. QUANTITY */}
                    <label style={s.label}>Quantity</label>
                    <input
                        style={s.input}
                        type="number"
                        value={quantity}
                        onChange={e => { e.target.setCustomValidity(''); setQuantity(e.target.value); }}
                        onInvalid={e => e.target.setCustomValidity('Please fill in this field')}
                        min={effectiveMin}
                        max={effectiveMax}
                        placeholder={`Min ${effectiveMin} — Max ${effectiveMax}`}
                        required
                    />
                    {qty > effectiveMax && effectiveMax > 0 && (
                        <div style={{ fontSize: 12, color: '#ef4444', marginTop: 4 }}>
                            Exceeds max capacity ({effectiveMax}) for this service
                        </div>
                    )}

                    {/* PRICE SUMMARY */}
                    {qty > 0 && svc && (
                        <div style={{ ...s.info, marginTop: 12 }}>
                            <strong>Total price:</strong> €{total.toFixed(4)}
                            &nbsp;|&nbsp;
                            <strong>Your balance:</strong> €{balance.toFixed(2)} &nbsp;
                            {total > balance && <span style={{ color: '#ef4444' }}>— Insufficient balance!</span>}
                        </div>
                    )}

                    {error && <div style={s.err}>{error}</div>}
                    {success && <div style={s.ok}>{success}</div>}

                    <button style={{ ...s.btn, opacity: submitting ? .6 : 1 }} disabled={submitting}>
                        {submitting ? 'Placing order...' : 'Place Order'}
                    </button>
                </form>
            </div>
        </div>
    );
}
